/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

const namespaced = true;

export default {
  namespaced,
  state() {
    return {
      entities: [],
      fetchedParentType: '',
      loading: true,
      submitting: false,
      serverError: '',
    };
  },
  actions: {
    async fetchEntities({ commit, state }, {
      parentType, parentId, entityType, forceLoad,
    }) {
      // only fetch if not already loaded
      if (state.entities.length === 0
        || state.entities[0].parentId !== parentId
        || state.fetchedParentType !== parentType
        || forceLoad) {
        commit('SET_LOADING', true);
        api.get(`${parentType}/${parentId}/${entityType}`)
          .then((response) => {
            commit('SET_ENTITIES', response.data);
            commit('SET_FETCHED_PARENT_TYPE', parentType);
            commit('SET_SERVER_ERROR', '');
            commit('SET_LOADING', false);
          })
          .catch((error) => {
            commit('SET_SERVER_ERROR', error.response.data);
            commit('SET_LOADING', false);
          });
      }
    },
    async createEntity({ commit, dispatch, rootState },
      {
        entityType, entity, closeForm, submittedCallback,
      }) {
      await api.post(`/${entityType}/create`, entity)
        .then(async (response) => {
          const newObj = entity;
          Object.assign(newObj, response.data);
          commit('ADD_NEW_ENTITY', newObj);
          commit('SET_SERVER_ERROR', '');
          commit('STOP_SUBMITTING');
          if (rootState.CurrentProject.currentProject) {
            const { id } = rootState.CurrentProject.currentProject;
            dispatch('CurrentProject/clearCurrentProject', null, { root: true });
            await dispatch('CurrentProject/fetch',
              { projectId: id },
              { root: true });
          }
          if (closeForm) closeForm(entity);
          if (submittedCallback) submittedCallback();
        }).catch((error) => {
          commit('SET_SERVER_ERROR', error.response.data);
          commit('STOP_SUBMITTING');
        });
    },
    async updateEntity({ commit, dispatch, rootState },
      {
        entityType, entity, closeForm, submittedCallback,
      }) {
      await api.put(`/${entityType}/update`, entity)
        .then(() => {
          commit('UPDATE_ENTITY', entity);
          commit('SET_SERVER_ERROR', '');
          commit('STOP_SUBMITTING');
          if (rootState.CurrentProject.currentProject) {
            const { id } = rootState.CurrentProject.currentProject;
            dispatch('CurrentProject/clearCurrentProject', null, { root: true });
            dispatch('CurrentProject/fetch',
              { projectId: id },
              { root: true });
          }
          if (closeForm) closeForm(entity);
          if (submittedCallback) submittedCallback(entity);
        }).catch((error) => {
          commit('SET_SERVER_ERROR', error.response.data);
          commit('STOP_SUBMITTING');
        });
    },
    async deleteEntity({ commit, dispatch, rootState }, { entityType, entity }) {
      await api.delete(`${entityType}/delete/${entity.id}`)
        .then(async () => {
          commit('REMOVE_ENTITY', entity);
          if (rootState.CurrentProject.currentProject) {
            const { id } = rootState.CurrentProject.currentProject;
            dispatch('CurrentProject/clearCurrentProject', null, { root: true });
            await dispatch('CurrentProject/fetch',
              { projectId: id },
              { root: true });
          }
        });
    },
    async startSubmitting({ commit }) {
      commit('START_SUBMITTING');
    },
    async stopSubmitting({ commit }) {
      commit('STOP_SUBMITTING');
    },
    async updateStoredEntity({ commit }, { entity }) {
      commit('UPDATE_ENTITY', entity);
    },
    async addNewEntity({ commit }, entity) {
      commit('ADD_NEW_ENTITY', entity);
    },
  },
  mutations: {
    ADD_NEW_ENTITY(state, newObj) {
      state.entities.push(newObj);
    },
    REMOVE_ENTITY(state, entity) {
      state.entities
        .splice(state.entities.indexOf(entity), 1);
    },
    SET_ENTITIES(state, entities) {
      state.entities = entities;
    },
    SET_FETCHED_PARENT_TYPE(state, fetchedParentType) {
      state.fetchedParentType = fetchedParentType;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_SERVER_ERROR(state, serverError) {
      state.serverError = serverError;
    },
    START_SUBMITTING(state) {
      state.submitting = true;
    },
    STOP_SUBMITTING(state) {
      state.submitting = false;
    },
    UPDATE_ENTITY(state, entity) {
      state.entities.splice(state.entities
        .findIndex(ent => ent.id === entity.id), 1, entity);
    },
  },
};
